import { EyeClosedIcon, EyeOpenIcon } from "@design-system/components/Icons";
import {
  matchRule,
  maxLengthRule,
  minLengthRule,
  patternRule,
  requiredRule,
} from "@mongez/react-form";
import { useState } from "react";
import { BaseInput, type BaseInputProps } from "./BaseInput";

type PasswordInputProps = BaseInputProps & {
  /**
   * Whether to show the password reveal toggle
   * @default false
   */
  revealable?: boolean;
  /**
   * The minimum length of the password
   */
  minLength?: number;
  /**
   * The maximum length of the password
   */
  maxLength?: number;
  /**
   * pattern to match the password
   */
  pattern?: RegExp;
  /**
   * The form control name to be matching with the current password input
   */
  match?: string;
};

export function PasswordInput({
  revealable = true,
  ...props
}: PasswordInputProps) {
  const [isRevealed, setIsRevealed] = useState(false);

  const toggleReveal = () => {
    setIsRevealed(prev => !prev);
  };

  const revealButton = revealable ? (
    <button
      type="button"
      onClick={toggleReveal}
      className="focus:outline-none"
      tabIndex={-1}>
      {isRevealed ? (
        <EyeClosedIcon className="w-4 h-4 text-muted-foreground hover:text-foreground transition-colors" />
      ) : (
        <EyeOpenIcon className="w-4 h-4 text-muted-foreground hover:text-foreground transition-colors" />
      )}
    </button>
  ) : null;

  return (
    <BaseInput
      rules={[
        requiredRule,
        minLengthRule,
        maxLengthRule,
        patternRule,
        matchRule,
      ]}
      {...props}
      type={isRevealed ? "text" : "password"}
      rightSide={revealable ? revealButton : props.leftSide}
    />
  );
}
